module.exports = __webpack_public_path__ + "img/1508396702.28e7c380.jpg";